<div class="site-container">
   <!--[ngClass]="{'hybrid-view': isDotNetInteroperable()}"-->
   @if(user()) {
   <app-internal-header [leadSection]="leadSection" class="flex-grow-0 flex-shrink-1 flex-basis-auto"></app-internal-header>
   }
   @else {
   <app-public-header></app-public-header>
   }

   <section>
      <router-outlet></router-outlet>
   </section>

   <app-site-footer class="flex-grow-0 flex-shrink-1"></app-site-footer>
</div>
